<template>
  <div class="form-card">
    <div class="form-card__header">
      <h6 class="form-card__title">
        <i class="bi bi-gear"></i>
        Configuración
      </h6>
    </div>
    <div class="form-card__body">
    <div class="row">
      <div class="col-md-4">
        <div class="form-card__field">
          <label class="form-card__label">Caja para compras y ventas</label>
          <select name="fund_id" v-model="bo_configs.fund_id" class="form-control" required>
            <option v-for="fund in funds" :key="fund.id" :value="fund.id">{{ fund.name }}</option>
          </select>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-card__field">
          <label class="form-card__label">Punto de Venta por defecto</label>
          <select name="pos_id" v-model="bo_configs.pos_id" class="form-control" required>
            <option v-for="pos in bo_pos" :key="pos.id" :value="pos.id">{{ pos.number }}</option>
          </select>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-card__field">
          <label class="form-card__label">Lista de venta por defecto</label>
          <select class="form-control" v-model="bo_configs.pricelist_id" name="pricelist">
            <option
              v-for="priceslist in priceslists"
              :key="priceslist.id"
              :value="priceslist.id"
            >{{ priceslist.name }}</option>
          </select>
        </div>
      </div>
    </div>
    </div>
    <!-- token de mercado pago temporalmente deshabilitado
    <div class="row">
      <div class="col-md-4">
        <div class="form-card__field">
          <label class="form-card__label">Token de MP</label>
          <input name="mptoken" v-model="bo_configs.mptoken" class="form-control" required>
        </div>
      </div>
      <div class="col-md-1">
        <div class="form-card__field" v-if="bo_configs.mptoken!=null">
          <button type="button" class="form-card__btn" @click="fetchqrs">Traer QRs</button>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-card__field" v-if="qrs.length>0">
          <label class="form-card__label">Seleccion QR</label>
          <select name="mpqr" v-model="selectedMPStore" class="form-control" required>
            <option v-for="qr in qrs" :key="qr.id" :value="qr.id">{{ qr.name }}</option>
          </select>
        </div>
      </div>
      <div class="col-md-1">
        <div class="form-card__field" v-if="qrs.length>0">
          <button type="button" class="form-card__btn" @click="renameEntities">Vincular</button>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-card__field">
          <label class="form-card__label">Tienda Externa</label>
          <input name="mpstore" v-model="bo_configs.mpstore" class="form-control" required>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-card__field">
          <label class="form-card__label">Caja Externa</label>
          <input name="mpqr" v-model="bo_configs.mpqr" class="form-control" required>
        </div>
      </div>
    </div>
    -->
  </div>
</template>

<script>
export default {
  props: ["bo_configs", "bo_pos", "funds", "bo_id"],
  data: function() {
    return {
      prueba: null,
      priceslists: [],
      qrs: [],
      selectedMPStore: null
    };
  },
  mounted: function() {
    return this.loadPriceLists();
  },
  methods: {
    renameEntities() {
      let vm = this;
      this.$http.post(`/api/configs/renameEntities/${vm.bo_configs.mptoken}/${vm.selectedMPStore}`)
      .then((response) => {
          if (response.status==200) {
            vm.bo_configs.mpstore = response.data.data.mpstore;
            vm.bo_configs.mpqr = response.data.data.mpqr;
          }
      }).catch((error) => {
          console.log('error: '+error);
      })
    },
    fetchqrs(){
        let vm = this;
        this.$http.get("/api/configs/fetchqrs/"+vm.bo_configs.mptoken)
        .then((response) => {
            if (response.status==200) {
              vm.qrs = response.data.data;
            }
        }).catch((error) => {
            console.log('error: '+error);
        })
    },
    loadPriceLists(){
        let vm = this;
        this.$http.get("/api/priceslist/getPriceList")
        .then((response) => {
            if (response.status==200) {
                vm.priceslists = response.data.data;
            } else {
              // no-op intencional
                
            }
        }).catch((error) => {
            console.log('error: '+error);
        })
    },
  }
};
</script>
